<template>
  <div>
    <button class="btn btn-info m-2" @click="goBack">Back</button>
    <card class="card" title="Add Institution">
      <div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Institution"
                placeholder="Institution Name"
                v-model="institution.institutionName"
                required
              >
              </fg-input>
            </div>
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Company Name"
                placeholder="Company Name"
                v-model="institution.companyName"
                required
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="text"
                label="RC Number"
                placeholder="RC Number"
                v-model="institution.regNumber"
                required
              >
              </fg-input>
            </div>

            <div class="col-md-6">
              <label>Institution Type</label>
              <select
                class="form-control"
                v-model="institution.institutionType"
                placeholder="Select an institution Type"
              >
                <option value="">Select an institution Type</option>
                <option value="bank">Bank</option>
                <option value="super-agent">Super Agent</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Email"
                placeholder="Email"
                v-model="institution.email"
              >
              </fg-input>
            </div>
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Address"
                placeholder="Address"
                v-model="institution.address"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <fg-input
                type="text"
                label="Phone Number"
                placeholder="Phone Number"
                v-model="institution.phoneNumber"
                maxlength="11"
                @input="
                  institution.phoneNumber = institution.phoneNumber.replace(
                    /\D/g,
                    ''
                  )
                "
              >
              </fg-input>
            </div>
          </div>

          <!-- <div class="row">
           <div class="col-md-4">
              <label>Country</label>
            <select
              class="form-control op-border"
              id="rate-type"
              v-model="institution.country"
              required
              @change="getStates()"
            >
              <option value="">country</option>
              <option v-for="(ct, index) in utils.countries" :key="index" :value="ct.code">
                {{ ct.name }}
              </option>
            </select>
          </div>

          <div class="col-md-4">
            <label>State</label>
            <select
              class="form-control op-border"
              id="rate-type"
              v-model="institution.state"
              required
              @change="fetchLgas()"
            >
              <option value="">State</option>
              <option v-for="st in utils.allStates" :key="st" :value="st">
                {{ st }}
              </option>
            </select>
          </div>

          <div class="col-md-4">
            <label>Local Government</label>
            <select
              class="form-control op-border"
              id="rate-type"
              v-model="institution.localGovernment"
              required
            >
              <option value="">Select Local Government</option>
              <option v-for="lg in utils.lgas" :key="lg.id" :value="lg.name">
                {{ lg.name }}
              </option>
            </select>
            <span v-if="utils.lgaLoading">
              Fetching Lga's
            </span>
          </div>
        </div> -->

          <div class="row">
            <div class="col-md-6 p-2">
              <label>Password</label>
              <input
                type="password"
                class="form-control border"
                label="Password"
                placeholder="Password"
                v-model="institution.password"
              />
            </div>
            <div class="col-md-6 p-2">
              <label>Password Confirmation</label>
              <input
                type="password"
                class="form-control border"
                label="Password Confirmation"
                placeholder="Password Confirmation"
                v-model="institution.password_confirmation"
              />
            </div>
          </div>

          <div class="text-center">
            <p-button type="info" round @click.native.prevent="submit">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Add Institution
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      institution: {
        institutionName: "",
        institutionType: "",
        regNumber: "",
        companyName: "",
        email: "",
        address: "",
        phoneNumber: "",
        country: "",
        state: "",
        password: "",
        password_confirmation: "",
        localGovernment: "",
      },
    };
  },
  computed: {
    ...mapState(["auth", "loading", "utils"]),
  },
  methods: {
    ...mapActions([
      "createInstitution",
      "getStates",
      "getLgas",
      "getCountries",
    ]),
    goBack() {
      window.history.back();
    },
    submit() {
      this.createInstitution(this.institution);
    },
    fetchLgas() {
      this.institution.lga = "";
      this.getLgas(this.institution.state);
    },
  },
  mounted() {
    this.getCountries();
  },
};
</script>
<style></style>
